/*
 *
 *  * Copyright (c) 2020 General Electric Company. All rights reserved.
 *  *
 *  * The copyright to the computer software herein is the property of
 *  * General Electric Company. The software may be used and/or copied only
 *  * with the written permission of General Electric Company or in accordance
 *  * with the terms and conditions stipulated in the agreement/contract
 *  * under which the software has been supplied.
 *
 */
export enum WorkListErrorCode {
  USER_DEFAULT_WL = 1,
  FILTER_NO_RESULTS = 2,
  NO_RESULTS = 3,
  SEARCH_NO_RESULTS = 4,
  TIMEOUT = 5,
  SEARCH_TIMEOUT = 6,
  WORK_LIST_DELETED = 7,
  XE_DOWN = 8,
  ERROR = 9
}
